import styled, { css } from 'styled-components';
import Badge from '../../../../_shared/components/Badge';
import Box from '../../../../_shared/components/Box';
import Label from '../../../../_shared/components/Label';
import CopyToClipboard from '../../../../_shared/components/CopyToClipboard';

export const Wrapper = styled(Box.Column)`
  background: ${({ theme }) => theme.COLORS.BASE};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  flex: 1 1 auto;
  max-width: inherit;
`;

export const BodyWrapper = styled(Box)`
  flex: 1 1 auto;
`;

export const StyledBody = styled(Box.Column)`
  flex: 1 1 auto;
`;

export const StyledBiddingBadges = styled(Box)`
  flex: 0 0 auto;
`;

export const Header = styled(Box)`
  align-items: flex-start;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const TextWrapContainer = styled.div`
  width: 332px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FooterWrapper = styled(Box)`
  flex: 0 0 auto;
`;

export const StyledDistanceWrapper = styled(Box)`
  flex: 1 1 auto;
`;

export const DistanceBox = styled(Header)`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  align-items: flex-end;
`;

export const StyledBadge = styled(Badge)`
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL_5};
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  border-radius: 18px;
  margin-right: 10px;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  text-align: center;
  height: 20px;
  padding: 0 12px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  display: flex;
  align-items: center;
  width: max-content;
`;

export const HasDisclosures = styled(StyledBadge)`
  border: 1px solid ${({ theme }) => theme.COLORS.ORANGE};
`;

export const StyledBiddingSection = styled(Box)``;

export const StyledTradeStateSection = styled(Box)`
  flex-direction: column;
  ${({ isOmp }) =>
    isOmp &&
    css`
      text-align: right;
    `}
`;

export const StyledTradeName = styled(Label.Bold)`
  margin-top: 3px;
  font-size: ${({ isOmp, theme }) =>
    isOmp ? theme.FONT_SIZES.LARGE : theme.FONT_SIZES.BASE};

  ${({ isOmp }) =>
    isOmp &&
    css`
      font-weight: ${({ theme }) => theme.FONT_WEIGHTS.SEMI_BOLD};
    `}
`;

export const StyledCopyToClipboard = styled(CopyToClipboard)`
  margin-top: 18px;
`;
